import { Icon, IconProps } from '@chakra-ui/react'

export function CryptoPaymentMethodIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 17 24" {...props}>
      <path
        d="M15.3822 7.18325C13.9421 5.33654 11.6944 4.14869 9.16893 4.14869C4.82239 4.14869 1.29883 7.66715 1.29883 12.0074C1.29883 16.3476 4.82239 19.866 9.16893 19.866C11.6944 19.866 13.9421 18.6782 15.3822 16.8315M7.50091 22.1709V19.6892M11.0488 4.14868V1.66699M7.50102 4.14868V1.66699M11.0488 22.2504V19.7687"
        stroke="currentColor"
        strokeOpacity="0.64"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </Icon>
  )
}
